import React from 'react';
// @ts-ignore
import PaymentImage from '../../assets/payment.png';

const QRCodeSection = () => {
  return (
    <div className="bg-white/80 backdrop-blur-sm p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 border border-white/20">
    <h3 className="text-2xl font-bold text-gray-800 mb-4">Scan to Pay</h3>
    <h4>Scan this QR code to proceed with your amount</h4>
    <img
      src={PaymentImage}
      alt="QR Code"
      className="mx-auto mb-4 mt-4"
    />
    <p className="text-lg text-gray-600 text-center mt-4">
      Payment will reflect in the system within 2 hours.
    </p>
  </div>
  );
};

export default QRCodeSection;